import { Component } from '@angular/core';
import { AuthGuard } from 'src/app/_helpers/auth.guard.service';
import { AuthenticationService } from 'src/app/_services/local/authentication.service';
import { UserInfos } from 'src/app/_models/user.infos';
@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html'
})
export class AppFooterComponent {
  public user: UserInfos;

  constructor(private auth: AuthenticationService) {
    this.user = this.auth.getUserInfos();
  }

  checkLogIn(): boolean {
    return this.user.success;
  }
}
